// extracted by mini-css-extract-plugin
module.exports = {"primaryLink":"PrimaryLink-module--primaryLink--tGhOn"};